import PropTypes from 'prop-types'

import { Typography, Box } from '@mui/material'
import useTranslations from '../../i18n/useTranslations'
import { useStyles } from './styles'

const AgendaView = ({
  children,
}) => {
  const t = useTranslations()
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <Box className={classes.rowHeader}>
        <Box className={classes.textHeader}>
          <Typography variant="h1" className={classes.title}>
            {t('agenda:title')}
          </Typography>
          <Typography className={classes.subtitle}>
            {t('agenda:description')}
          </Typography>
        </Box>
      </Box>
      {children}
    </Box>
  )
}

AgendaView.propTypes = {
  children: PropTypes.node,
}

export default AgendaView
